import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "admin@quickie.com",
    password: "Admin@1234",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (!["admin", "super_admin", "branch_manager"].includes(user.role)) {
        setError("Access denied. Admin accounts only.");
        return;
      }
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-card">
        <div className="login-logo">
          <img
            src="/logo.png"
            alt="Kwikie Express Logo"
            className="logo-image"
          />
          <div className="login-sub">Admin Dashboard</div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="input"
              type="email"
              value={form.email}
              onChange={(e) =>
                setForm((f) => ({ ...f, email: e.target.value }))
              }
              placeholder="admin@quickie.com"
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="input"
              type="password"
              value={form.password}
              onChange={(e) =>
                setForm((f) => ({ ...f, password: e.target.value }))
              }
              placeholder="••••••••"
              required
            />
          </div>
          <button
            className="btn btn-primary w-full mt-16"
            type="submit"
            disabled={loading}
            style={{ justifyContent: "center" }}
          >
            {loading ? (
              <>
                <span className="spinner" style={{ width: 16, height: 16 }} />{" "}
                Signing in...
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>

        <p
          style={{
            textAlign: "center",
            marginTop: 20,
            fontSize: 12,
            color: "var(--text3)",
          }}
        >
          Quickie Delivery Platform · Admin Only
        </p>
      </div>
    </div>
  );
}